"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnePurchaseOrder = void 0;
const handle_error_1 = require("../../handle-error");
const buildPath = ({ partnerId, membershipNumber, purchaseOrderId }) => `/v1/bff/appro/partners/${partnerId}/memberships/${membershipNumber}/purchase-orders/${purchaseOrderId}`;
const getOnePurchaseOrder = (client, logger) => async (parameters) => {
    try {
        const response = await client.get(buildPath(parameters));
        return response.data;
    }
    catch (error) {
        (0, handle_error_1.handleError)(error, logger);
        return null;
    }
};
exports.getOnePurchaseOrder = getOnePurchaseOrder;
